import { FC } from "react"
import { DictionaryFileInput } from "../../../../components/controls/dictionaryFileInput"
import GridWrapper from "../../../../components/controls/GridWrapper"
import { IFileWrapper } from "../view/importRemainContent"
import { v4 as uuidv4 } from 'uuid';
import { renameFile } from "../function/functions"
import { DictionaryDropZone } from "../../../../components/controls/DropZone/dictionaryDropZone"
import { Delete3Icon } from "../../../../libs/corporate/icons/outlined/action/MainCollection"
import styles from '../styles/importRemainContent.module.scss'
import { Button } from "../../../../components/buttons/button"
import lgContentStyles from '../styles/lgWidthContent.module.scss'
import { importFileRequest } from "../../../../libs/core-api-requests/importFile/importCsvRequest"

interface ILgWidthContentProps {
    file: IFileWrapper,
    setFile: (value: IFileWrapper) => void,
    setSubmitting: (value: boolean) => void
    admissibleExtension: string;
    isSubmitting: boolean
    importFile: () => void
}

export const LgWidthMarketContractContent: FC<ILgWidthContentProps> = ({
    file,
    setFile, setSubmitting, isSubmitting, admissibleExtension, importFile
}) => {
    return <>
      
        <GridWrapper cols={19}>
            <DictionaryFileInput
                multiple={false}
                files={file.file}
                setFiles={(files: IFile[]) => {
                    const id = uuidv4();
                    setFile({ file: files, id: id });
                    importFileRequest(renameFile(files[0].file, `${id}.csv`), (value: boolean) => {
                        setSubmitting(value)
                    })
                }}
                label='Файл маркетингового договора'
                admissibleExtension={admissibleExtension}
                className={styles.fileInput}
            />
            <Delete3Icon className={styles.clearButton} onClick={() => { setFile({ file: [], id: null }) }}/>
            
        </GridWrapper>
        <DictionaryDropZone
            files={file.file}
            setFiles={(files: IFile[]) => {
                const id = uuidv4()
                setFile({ file: files, id: id })
                importFileRequest(renameFile(files[0].file, `${id}.csv`), (value: boolean) => {
                    setSubmitting(value)
                })
            }}
            isSubmitting={isSubmitting}
            admissibleExtension={admissibleExtension}
            multiple={false}
            fileWrapperClassName={styles.dropZone}
            wrapperStyle={styles.dropZoneWrapper}
        />


        <div className={lgContentStyles.buttonBlock}>           
            <Button
                variant='outprimary'
                className={lgContentStyles.button}
                isLoadingSpinner={isSubmitting}
                onClick={() => importFile()}
            >
                Импорт
            </Button>
        </div>
    </>
}